<template>
  <div>
    <div class="cont">
      <div class="title">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>工程概况</el-breadcrumb-item>
          <el-breadcrumb-item>项目概况</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="box">
        <div class="box-r">
          <div class="box-r-t">
           {{title}}
          </div>
          <div class="box-r-b">
            <div class="row">
              <div class="row-l"><span class="label">上级菜单：</span></div>
              <div class="row-r row-x">
                <el-cascader
                :disabled="typeAA==2"
                size="mini"
                  children="child"
                  v-model="form.parentId"
                  :options="list"
                  :props="{children:'child',checkStrictly: true}"
                  clearable></el-cascader>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label"><span style="color:#f00">*</span>菜单名称：</span></div>
              <div class="row-r">
                <el-input size="mini" v-model="form.surveyName" placeholder="请输入内容"
                ></el-input>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">项目效果图：</span></div>
              <div class="row-r">
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                   :headers="uploadHead"
                  :data="{ type: 259 }"
                  :on-success="onSuccess3"
                  :before-upload="beforeUpload3"
                  :on-remove="handleRemove3"
                  list-type="picture"
                  :file-list="listS3">
                  <!-- <img style="width:100px;" v-if="imageUrl1" :src="imageUrl1" class="avatar"> -->
                  <div class="btn" v-if="form.effectDrawingImg==''||form.effectDrawingImg==null">上传</div>
                </el-upload>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">现场安全标志平面布置图：</span></div>
              <div class="row-r">
                <el-upload
                :on-remove="handleRemove4"
                  class="upload-demo"
                  :action="uploadUrl"
                   :headers="uploadHead"
                  :data="{ type: 259 }"
                  :on-success="onSuccess4"
                  :before-upload="beforeUpload4"
                  list-type="picture"
                  :file-list="listS4"
                  >
                  <!-- <img style="width:100px;" v-if="imageUrl1" :src="imageUrl1" class="avatar"> -->
                  <div class="btn" v-if="form.safetySymbolImg==''||form.safetySymbolImg==null">上传</div>
                </el-upload>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">项目总平面布置图：</span></div>
              <div class="row-r">
                <el-upload
                  class="upload-demo"
                  :on-remove="handleRemove5"
                  :action="uploadUrl"
                   :headers="uploadHead"
                  :data="{ type: 259 }"
                  :on-success="onSuccess5"
                  :before-upload="beforeUpload5"
                  list-type="picture"
                  :file-list="listS5">
                  <!-- <img style="width:100px;" v-if="imageUrl1" :src="imageUrl1" class="avatar"> -->
                  <div class="btn" v-if="form.masterPlanImg==''||form.masterPlanImg==null">上传</div>
                </el-upload>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">现场临时用电平面布置图：</span></div>
              <div class="row-r">
                <el-upload
                  class="upload-demo"
                  :on-remove="handleRemove6"
                  :action="uploadUrl"
                   :headers="uploadHead"
                  :data="{ type: 259 }"
                  :on-success="onSuccess6"
                  :before-upload="beforeUpload6"
                  list-type="picture"
                  :file-list="listS6">
                  <!-- <img style="width:100px;" v-if="imageUrl1" :src="imageUrl1" class="avatar"> -->
                  <div class="btn" v-if="form.temporaryElectricity==''||form.temporaryElectricity==null">上传</div>
                </el-upload>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">建设单位：</span></div>
              <div class="row-r">
                <el-input v-model="form.builderUnits" size="mini" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">设计单位：</span></div>
              <div class="row-r">
                <el-input v-model="form.designUnits"  size="mini" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">勘察单位：</span></div>
              <div class="row-r">
                <el-input size="mini" v-model="form.explorationUnits" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">施工单位：</span></div>
              <div class="row-r">
                <el-input v-model="form.constructingUnits" size="mini" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">监理单位：</span></div>
              <div class="row-r">
                <el-input v-model="form.supervisionUnits" size="mini" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">建设平方：</span></div>
              <div class="row-r">
                <el-input v-model="form.constructionSquare" size="mini" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">施工许可证：</span></div>
              <div class="row-r">
                <el-input v-model="form.builderLicence" size="mini" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">合同价格：</span></div>
              <div class="row-r">
                <el-input v-model="form.contractPrice" size="mini" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">合同开工日期：</span></div>
              <div class="row-r row-x">
                <el-date-picker
                value-format="yyyy-MM-dd"
                size="mini"
                  v-model="form.contractStartDate"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">合同竣工日期：</span></div>
              <div class="row-r row-x">
                <el-date-picker
                value-format="yyyy-MM-dd"
                size="mini"
                  v-model="form.contractEndDate"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">合同工期：</span></div>
              <div class="row-r row-x">
                <el-input v-model="form.contractDuration" size="mini" placeholder="请输入内容"></el-input>
              </div>
            </div>
            <div class="row rowx">
              <div class="row-l"><span class="label">四证一书：</span></div>
              <div class="row-r">
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="uploadHead"
                  :data="{ type: 259 }"
                  :before-upload="beforeUpload1"
                  :on-remove="handleRemove1"
                  multiple
                  :limit="5"
                  :on-exceed="onExceed1"
                  :on-error="onError1"
                  :on-success="onSuccess1"
                  :file-list="listS1"
                  >
                  <div class="btn">上传</div>
                </el-upload>
              </div>
            </div>
            <div class="row rowx">
              <div class="row-l"><span class="label">项目计划进度表：</span></div>
              <div class="row-r">
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="uploadHead"
                  :data="{ type: 259 }"
                  :before-upload="beforeUpload2"
                  :on-remove="handleRemove2"
                  multiple
                  :limit="10"
                  :on-exceed="onExceed2"
                  :on-error="onError2"
                  :on-success="onSuccess2"
                  :file-list="listS2"
                  >
                  <div class="btn">上传</div>
                </el-upload>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">项目地址：</span></div>
              <div class="row-r">
                <el-input v-model="form.projectAddress" size="mini" placeholder="请输入内容"
                :maxlength="255"
                ></el-input>
              </div>
            </div>
            <div class="row">
              <div class="row-l"><span class="label">项目介绍：</span></div>
              <div class="row-r">
                <el-input
                maxlength="1000"
                show-word-limit
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="form.surveyDesc"
                  :maxlength="1500"
                show-word-limit>
                </el-input>
              </div>
            </div>
          </div>
          <div class="box-b">
            <div class="btn1" @click="exit">取消</div>
            <div class="btn2" @click="createInfo">确认</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
import { number } from 'echarts'
  export default {
    data() {
      return {

        title:'项目信息编辑',
        form:{
          parentId:[],
          groupId:util.session.get('groupId'),
          surveyName:'',
          effectDrawingImg:'',
          safetySymbolImg:'',
          masterPlanImg:'',
          temporaryElectricity:'',
          builderUnits:'',
          designUnits:'',
          explorationUnits:'',
          constructingUnits:'',
          supervisionUnits:'',
          constructionSquare:'',
          builderLicence:'',
          contractPrice:'',
          contractStartDate:'',
          contractEndDate:'',
          contractDuration:'',
          certificats:'',
          projectProcess:'',
          projectAddress:'',
          createBy:util.session.get('user').id,
          surveyDesc:''
        },
        uploadUrl: base.url + '/upload/uploadPhoto', //上传地址
        uploadHead: {
            //上传接口header
            accessToken: this.$store.state.token,
          },
        // 1
        options:[],
        fileIndex1:0,
        success1:0,
        uploadLock1:true,
        fileList1:[],
        listS1:[],
        // 2
        fileIndex2:0,
        success2:0,
        uploadLock2:true,
        fileList2:[],
        listS2:[],
        listS3:[],
        listS4:[],
        listS5:[],
        listS6:[],
        imageUrl1:'',
        imageUrl2:'',
        imageUrl3:'',
        imageUrl4:'',
        uploadLock3:true,
        uploadLock4:true,
        uploadLock5:true,
        uploadLock6:true,
        list:[],
        typeAA:1
      }
    },
    mounted(){
      this.typeAA=this.$route.query.type
      console.log(this.form.parentId)
      if(this.$route.query.type==1){
        this.title="项目信息创建"
      }else{
        this.title="项目信息编辑"
      }
      this.getList()
      if(this.$route.query.type==1){

      }else if(this.$route.query.type==2){
        myHttp.getProjectSurveyBySurveyId({
          groupId:util.session.get('groupId'),
          surveyId:this.$route.query.id
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            for(let key in this.form){
              this.form[key]=res.data.data[key]
            }
            this.form.parentId = res.data.data['parentId']
            let item = JSON.parse(this.form.certificats)
            item.forEach((itemA,indexA)=>{
              this.listS1.push({name:itemA.fileName,url:itemA.fileUrl})
              this.fileList1.push({fileName:itemA.fileName,fileUrl:itemA.fileUrl})
              this.fileIndex1++
              this.success1++
            })
            let item2 = JSON.parse(this.form.projectProcess)
            item2.forEach((itemA,indexA)=>{
              this.listS2.push({name:itemA.fileName,url:itemA.fileUrl})
              this.fileList2.push({fileName:itemA.fileName,fileUrl:itemA.fileUrl})
              this.fileIndex2++
              this.success2++
            })
            if(this.form.effectDrawingImg!=''&&this.form.effectDrawingImg!=null){
              this.listS3.push({name:this.form.effectDrawingImg.split('/')[this.form.effectDrawingImg.split('/').length-1],url:base.httpCtx+this.form.effectDrawingImg})
            }
            if(this.form.safetySymbolImg!=''&&this.form.safetySymbolImg!=null){
              this.listS4.push({name:this.form.safetySymbolImg.split('/')[this.form.safetySymbolImg.split('/').length-1],url:base.httpCtx+this.form.safetySymbolImg})
            }
            if(this.form.masterPlanImg!=''&&this.form.masterPlanImg!=null){
              this.listS5.push({name:this.form.masterPlanImg.split('/')[this.form.masterPlanImg.split('/').length-1],url:base.httpCtx+this.form.masterPlanImg})
            }
            if(this.form.temporaryElectricity!=''&&this.form.temporaryElectricity!=null){
              this.listS6.push({name:this.form.temporaryElectricity.split('/')[this.form.temporaryElectricity.split('/').length-1],url:base.httpCtx+this.form.temporaryElectricity})
            }
            
            
            
            
          }
        })
      }
    },
    methods:{
      onExceed1(){
        this.$message({
          type:'error',
          message:'最多上传5个文件！'
        })
      },
      onExceed2(){
        this.$message({
          type:'error',
          message:'最多上传10个文件！'
        })
      },
      // 1
      getList(){
        let that = this
        myHttp.getProjectSurveyByGroupId({
          groupId:util.session.get('groupId')
        }).then(res=>{
          if(res.data.code==200){
            that.list = res.data.data
            // this.getPartyBuildingActiveFileByPartybuildId(that.list[0].value)
            // that.listItemId = that.list[0].value
            // that.currentNodekey = res.data.data[0].value
            // that.expandedkeys.push(res.data.data[0].value)
            // that.$nextTick(() => {
            //   // treeBox 元素的ref   value 绑定的node-key
            //   that.$refs.tree.setCurrentKey(that.currentNodekey)
            // })
          }
        })
      },
      onSuccess1(item,i,l){
        console.log(item,i,l)
        this.success1++
        this.fileList1.push({fileName:i.name,fileUrl:item.data.saveUrls})
        if(this.success1==this.fileIndex1){
          this.uploadLock1=true
        }
      },
      onError1(item){
        this.fileIndex1--
        if(this.fileIndex1<0){
          this.fileIndex1=0
        }
        if(this.success1>this.fileIndex1){
          this.fileIndex1++
        }
      },
      beforeUpload1(item,i){
        this.fileIndex1++
        this.uploadLock1=false

        if(item.name.split('.')[item.name.split('.').length-1]=='doc'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='docx'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='pdf'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='PDF'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='xlsx'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='xls'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='text'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='txt'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='png'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='jpg'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='jepg'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='jfif'){
          return true
        }
        this.uploadLock1=true
        this.$message({
          type:'error',
          message:'请上传正确的文件格式（doc,docx,xlsx, xls,pdf,PDF,text,txt）'
        })
        return false
      },
      handleRemove1(item,i,l){
        console.log(item)
        if(item.status=='success'){
          this.fileList1.forEach((itemA,index)=>{
            if(itemA.fileName==item.name){
              this.fileList1.splice(index,1)
            }
          })
          this.success1--
          if(this.success1<0){
            this.success1=0
          }
        }
        this.fileIndex1--
        if(this.fileIndex1<0){
          this.fileIndex1=0
        }
      },
      // 2
      onSuccess2(item,i,l){
        console.log(item,i,l)
        this.success2++
        this.fileList2.push({fileName:i.name,fileUrl:item.data.saveUrls})
        if(this.success2==this.fileIndex2){
          this.uploadLock2=true
        }
      },
      onError2(item){
        this.fileIndex2--
        if(this.fileIndex2<0){
          this.fileIndex2=0
        }
        if(this.success2>this.fileIndex2){
          this.fileIndex2++
        }
      },
      beforeUpload2(item,i){
        this.fileIndex2++
        this.uploadLock2=false
        if(item.name.split('.')[item.name.split('.').length-1]=='doc'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='docx'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='pdf'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='PDF'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='xlsx'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='xls'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='text'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='txt'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='png'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='jpg'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='jepg'){
          return true
        }
        if(item.name.split('.')[item.name.split('.').length-1]=='jfif'){
          return true
        }
        this.$message({
          type:'error',
          message:'请上传正确的文件格式（doc,docx,xlsx, xls,pdf,PDF,text,txt）'
        })
        this.uploadLock2=false
        return false
      },
      handleRemove2(item,i,l){
        console.log(item)
        if(item.status=='success'){
          this.fileList2.forEach((itemA,index)=>{
            if(itemA.fileName==item.name){
              this.fileList2.splice(index,1)
            }
          })
          this.success2--
          if(this.success2<0){
            this.success2=0
          }
        }
        this.fileIndex2--
        if(this.fileIndex2<0){
          this.fileIndex2=0
        }
      },
      // 3
      handleRemove3(item,i,l){
        this.form.effectDrawingImg = ''
      },
      onSuccess3(item,file,l){
        this.imageUrl1 = URL.createObjectURL(file.raw);
        this.form.effectDrawingImg = item.data.saveUrls
          this.uploadLock3=true
      },
      beforeUpload3(item,i){
        this.uploadLock3=false
        if(item.name.split('.')[item.name.split('.').length-1]=='png'){
          return true
        }
        else if(item.name.split('.')[item.name.split('.').length-1]=='jpg'){
          return true
        }
        else  if(item.name.split('.')[item.name.split('.').length-1]=='jepg'){
          return true
        }
        else  if(item.name.split('.')[item.name.split('.').length-1]=='jfif'){
          return true
        }else{
          this.uploadLock3=true

          this.$message({
            type:'error',
            message:'请上传正确的文件格式（png,jpg,jepg,jfif）'
          })
          return false
        }
      },
      // 4
      handleRemove4(item,i,l){
        this.form.safetySymbolImg = ''
      },
      onSuccess4(item,file,l){
        this.imageUrl2 = URL.createObjectURL(file.raw);
        this.form.safetySymbolImg = item.data.saveUrls
        this.uploadLock4=true
      },
      beforeUpload4(item,i){
        this.uploadLock4=false
        if(item.name.split('.')[item.name.split('.').length-1]=='png'){
          return true
        }
        else if(item.name.split('.')[item.name.split('.').length-1]=='jpg'){
          return true
        }
        else  if(item.name.split('.')[item.name.split('.').length-1]=='jepg'){
          return true
        }
        else  if(item.name.split('.')[item.name.split('.').length-1]=='jfif'){
          return true
        }else{
          this.uploadLock4=true

          this.$message({
            type:'error',
            message:'请上传正确的文件格式（png,jpg,jepg,jfif）'
          })
          return false
        }
      },
      // 5
      handleRemove5(item,i,l){
        this.form.masterPlanImg = ''
      },
      onSuccess5(item,file,l){
        this.imageUrl3 = URL.createObjectURL(file.raw);
        this.form.masterPlanImg = item.data.saveUrls
          this.uploadLock5=true
      },
      beforeUpload5(item,i){
        this.uploadLock5=false
        if(item.name.split('.')[item.name.split('.').length-1]=='png'){
          return true
        }
        else if(item.name.split('.')[item.name.split('.').length-1]=='jpg'){
          return true
        }
        else  if(item.name.split('.')[item.name.split('.').length-1]=='jepg'){
          return true
        }
        else  if(item.name.split('.')[item.name.split('.').length-1]=='jfif'){
          return true
        }else{
          this.uploadLock5=true
          this.$message({
            type:'error',
            message:'请上传正确的文件格式（png,jpg,jepg,jfif）'
          })
          return false
        }
      },
      // 6
      handleRemove6(item,i,l){
        this.form.temporaryElectricity = ''
      },
      onSuccess6(item,file,l){
        this.imageUrl4 = URL.createObjectURL(file.raw);
        this.form.temporaryElectricity = item.data.saveUrls
          this.uploadLock6=true
      },
      beforeUpload6(item,i){
        this.uploadLock6=false
        if(item.name.split('.')[item.name.split('.').length-1]=='png'){
          return true
        }
        else if(item.name.split('.')[item.name.split('.').length-1]=='jpg'){
          return true
        }
        else  if(item.name.split('.')[item.name.split('.').length-1]=='jepg'){
          return true
        }
        else  if(item.name.split('.')[item.name.split('.').length-1]=='jfif'){
          return true
        }else{
          this.uploadLock6=true
          this.$message({
            type:'error',
            message:'请上传正确的文件格式（png,jpg,jepg,jfif）'
          })
          return false
        }
      },
      //
      exit(){
        this.$router.replace('/projectOverviewCompile')
      },
      createInfo(){
        let that = this
        if(this.form.surveyName==''){
          this.$message({
            type:'error',
            message:'菜单名称不能为空'
          })
        }else{
          if(this.uploadLock1&&this.uploadLock2&&this.uploadLock3&&this.uploadLock4&&this.uploadLock5&&this.uploadLock6){0

            // let list1 = { ...this.fileList1 }
            // this.fileList1= JSON.stringify(list1)
            // let list2 = { ...this.fileList2 }
            // this.fileList2= JSON.stringify(list2)
            this.form.certificats=JSON.stringify(this.fileList1)
            this.form.projectProcess=JSON.stringify(this.fileList2)
            if(this.$route.query.type==1){
              if(this.form.parentId.length!=0){
                this.form.parentId = this.form.parentId[this.form.parentId.length-1]
              }else{
                this.form.parentId = '0'
              }
              myHttp.createInfoXMCJ(this.form).then(res=>{
                console.log(res)
                if(res.data.code==200){
                  this.$message({
                    type:'success',
                    message:res.data.msg
                  })
                  this.exit()
                }else{
                  this.$message({
                    type:'warning',
                    message:res.data.msg
                  })
                }
              })
            }else{
              delete this.form.createBy
              this.form.updateBy = util.session.get('user').id
              this.form.surveyId = this.$route.query.id
              console.log(this.form)
              myHttp.updateInfoXMGK(this.form).then(res=>{
                console.log(res)
                if(res.data.code==200){
                  this.$message({
                    type:'success',
                    message:res.data.msg
                  })
                  this.exit()
                }else{
                  this.$message({
                    type:'warning',
                    message:res.data.msg
                  })
                }
              })
            }
          }else{
            this.$message({
              type:'warning',
              message:'文件正在上传中...'
            })
          }
        }
      },
    }
  }
</script>

<style scoped>
.cont{
  width: 100%;
  height: 100%;
  background-color: rgb(236,240,245);
  padding: 0 24px 0px 8px;
}
.title{
  height: 4vh;
  display: flex;
  align-items: center;
}
.box{
  display: flex;
  height: 79vh;
}

.box-r{
  border-radius: 6px;
background: #FFFFFF;
box-shadow: 5px 4px 10px -2px rgba(0, 0, 0, 0.25);
  flex: 1;
  overflow: hidden;
}
.box-r-t{
  height: 4vh;
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 0 16px;
  border-bottom: 2px solid #ECF0F5;
  font-family: SourceHanSansCN-Regular;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #9E9E9E;
}
.box-r-b{
  /* background-color: #f00; */
  padding-top: 10px;
  height: 71vh;
  padding-left:16px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.row{
  width: 26vw;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.row-l{
   width: 198px;
  text-align: end;
      height: 100%;
}
.row-r{
  text-align: start;
}
.label{
  font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #9E9E9E;
}
::v-deep .el-input--mini {
  width: 300px;
}
.row-x>::v-deep .el-input--mini {
  width: 200px;
}
.btn{
  width: 50px;
height: 28px;
border-radius: 2px;
background: #ECF5FF;
box-sizing: border-box;
border: 1px solid #B3D8FF;
font-family: MicrosoftYaHeiLight;
font-size: 13px;
font-weight: 290;
letter-spacing: 0em;
color: #409EFF;
display: flex;
justify-content: center;
align-items: center;
}
.btn:hover{
  cursor: pointer;
  opacity: 0.7;
}
.box-b{
  height: 4.5vh;
  display: flex;justify-content: center;
  align-items: center;
  box-shadow: 0px -10px 21px 0px rgba(225, 225, 225, 0.3);
}
.btn1{
width: 54px;
height: 28px;
border-radius: 4px;
background: #FFFFFF;
box-sizing: border-box;
border: 1px solid #B3D8FF;
font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #409EFF;
display: flex;justify-content: center;
  align-items: center;
}
.btn2{
  margin-left: 30px;
  width: 54px;
height: 28px;
border-radius: 4px;
background: #409EFF;
font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #FFFFFF;
display: flex;justify-content: center;
  align-items: center;
}
.btn1:hover,.btn2:hover{
  cursor: pointer;
  opacity: 0.7;
}
::v-deep .el-upload-list--picture .el-upload-list__item.is-success .el-upload-list__item-name{
  line-height: 100% !important;
  
}
.rowx>::v-deep .el-upload-list__item-name{
font-size: 14px !important;
}
::v-deep .el-textarea{
  width: 250px;
}
</style>